<form [formGroup]="loginForm" (ngSubmit)="submitForm()">
    <ion-input
        #usernameInput
        [formControlErrorMessages]="validationMessages.username"
        [formControl]="loginForm.controls.username"
        autocomplete="email"
        fill="outline"
        inputmode="email"
        label="Email"
        labelPlacement="floating"
        mode="md"
        type="email"
    />
    <ion-input
        #passwordInput
        [formControlErrorMessages]="validationMessages.password"
        [formControl]="loginForm.controls.password"
        autocomplete="current-password"
        fill="outline"
        id="password-input"
        label="Password"
        labelPlacement="floating"
        libPasswordInputToggle
        mode="md"
    />
    <ion-button
        [disabled]="!loginForm.valid"
        class="ion-margin-bottom"
        expand="block"
        type="submit"
    >
        Log in
    </ion-button>
</form>
